import React, {useState} from 'react';
import BigHeadline from "./BigHeadline/BigHeadline";
import BigNumber from "./BigNumber/BigNumber";
import ImageText from "./ImageText/ImageText";
import Graphic from "./Graphic/Graphic";


interface BtnProps {
  backBtnLabel:string;
  closeLayer: (e: any) => void;
  topicContent: any;
}

const AvTopicLineContent = (props: BtnProps) => {
  const { backBtnLabel,closeLayer, topicContent} = props;
  const [tabIndex] = useState(-1);

  const getComponentSwitch = (index:number, obj:any, el:string) => {
    switch (obj.module) {
      case 'BigHeadline':
        return <BigHeadline key={index} headline={obj.headline} text={obj?.text}el={el} />;
      case 'BigNumber':
        return <BigNumber key={index} number={obj.number} inscription={obj.inscription} el={el} />;
      case 'ImageText':
        return <ImageText key={index} headline={obj?.headline} text={obj?.text} image={obj.image}el={el} />;
      case 'Graphic':
        return <Graphic key={index} headline={obj?.headline} text={obj?.text} image={obj.image} el={el} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="av-topic-line-content">
        <div className="av-topic-line-content__wrapper">
          <ul className="av-topic-line-content__box">
            {
              topicContent?.map((entry:any, key:any) => {
                const index = key + 1;

                return (
                  <>
                    <li className="av-topic-line-content__item" key={index}>
                      { getComponentSwitch(index, entry, topicContent.length === index ? 'last': '') }
                    </li>
                    {/* empty element needed for positioning of items in grid */}
                    <li aria-hidden="true"/>
                  </>
                );
              }
            )}
          </ul>
        </div>
        <div className="av-topic-line-content__btn-arrow">
          <button  type='button' className="av-topic-line__button" aria-hidden="true" tabIndex={tabIndex} onClick={closeLayer}>
            <span className='ic-arrowUp'/>
          </button>
          <a className="av-topic-line-content__back-label" href="#" onClick={ (e) => closeLayer(e)} aria-label={backBtnLabel}>{backBtnLabel}</a>
        </div>
      </div>
    </>
  );
};

export default AvTopicLineContent;
